// extracted by mini-css-extract-plugin
export var Search = "search-module--Search--2rbzm";
export var Search__icon = "search-module--Search__icon--2ZuUf";
export var Search__field = "search-module--Search__field--2HJrM";